import { makeStyles } from "@material-ui/core";

/**
 * Grid spacing pulls a row out by half the gutter on each side, which on a phone ate most
 * of the page Container's own padding and left the cards against the screen edge. Matching
 * that inset back on restores the gutter at every width. Shared by every reports tab so
 * they cannot drift apart.
 */
export const useReportGridStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(4),
    [theme.breakpoints.up("md")]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(8),
    },
  },
}));
